class Top {
  constructor(el,opt){
    this.el = el;
    this.lenis = null; // Lenisインスタンスを保存
    this.lastScrollY = 0; // 前回のスクロール位置を保存
    this.rafId = null; // requestAnimationFrameのIDを保存
    this.isDesktop = window.innerWidth >= 768; // 初期の画面サイズを判定
    this.onGsapTick = null;
    
    if($("." + this.el).length > 0){
      this.init();
    }
  }
  
  init(){
    // ScrollTriggerとLenisの統合を待つ
    this.smoothScroll();
    this.setupDrawerLenisControl();
    this.headerScrollControl(); // ヘッダーのスクロール制御を追加
    this.handleResize(); // リサイズイベントを追加
    this.event(); // 元のTopクラスのeventメソッドを実行
  }
  event(){
    const mvSwiper01 = new Swiper('.mv-swiper01', {
      loop: true,
      speed: 1000,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    const mvSwiper02 = new Swiper('.mv-swiper02', {
      loop: true, 
      speed: 1000,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    const mvSwiper03 = new Swiper('.mv-swiper03', {
      loop: true,
      speed: 1000, 
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    // .js-sticky-photo要素のScrollTriggerアニメーション
    gsap.registerPlugin(ScrollTrigger);
    
    const stickyPhotos = document.querySelectorAll('.js-sticky-photo');
    
    stickyPhotos.forEach((photo) => {
      gsap.fromTo(photo, 
        {
          scale: 1,
          opacity: 1
        },
        {
          scale: 0.6,
          opacity: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: photo,
            start: "top+=300 top",
            end: "top+=1500 top", // 3画面分（約200vhの追加スクロール）
            scrub: 2 // スムーズなスクロール連動
          }
        }
      );
    });

    // .js-parallax-img要素のパララックス効果
    const parallaxImages = document.querySelectorAll('.js-parallax-img');
    
    parallaxImages.forEach((img) => {
      // レスポンシブ対応：767px以下でdata-sp-yがある場合はそちらを優先
      let moveDistance;
      const isSmallScreen = window.innerWidth <= 767;
      const spY = img.dataset.spY;
      const normalY = img.dataset.y;
      
      if (isSmallScreen && spY !== undefined) {
        moveDistance = parseInt(spY);
      } else {
        moveDistance = parseInt(normalY) || -30;
      }
      
      gsap.fromTo(img,
        {
          y: 0
        },
        {
          y: moveDistance, // 適切な値分移動
          ease: "none",
          scrollTrigger: {
            trigger: img,
            start: "top bottom", // 画面下部に入った時に開始
            end: "top top", // 画面上部を通過する時に終了
            scrub: 3, // スクロールに同期してスムーズに実行
          }
        }
      );
    });
  }

  smoothScroll(){
    // 768px以上でのみLenisを初期化
    if (this.isDesktop) {
      this.initLenis();
    }
  }

  initLenis(){
    if (typeof Lenis === 'undefined') return;

    // 二重初期化防止
    this.destroyLenis();

    this.lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      syncTouch: false,
    });

    // GSAP ticker と統合（独自 RAF との二重駆動を避ける）
    this.lenis.on('scroll', () => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.update();
      }
    });

    this.onGsapTick = (time) => {
      if (this.lenis) {
        this.lenis.raf(time * 1000);
      }
    };
    gsap.ticker.add(this.onGsapTick);
    gsap.ticker.lagSmoothing(0);

    // アンカーリンクをLenisでスクロールさせる
    this.setupAnchorLinks();
  }

  destroyLenis(){
    if (this.onGsapTick) {
      gsap.ticker.remove(this.onGsapTick);
      this.onGsapTick = null;
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
    }
  }

  setupAnchorLinks(){
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      const handleClick = (e) => {
        e.preventDefault();
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          if (this.lenis && this.isDesktop) {
            // PCの場合はLenisでスムーススクロール
            this.lenis.scrollTo(target, {
              offset: 0,
              duration: 1.5
            });
          } else {
            // モバイルの場合は通常のスクロール
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      };
      
      // 既存のイベントリスナーを削除してから新しいものを追加
      anchor.removeEventListener('click', handleClick);
      anchor.addEventListener('click', handleClick);
    });
  }

  handleResize(){
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 768;
      
      // デスクトップ⇔モバイルの切り替え時のみLenisの初期化/破棄を実行
      if (wasDesktop !== this.isDesktop) {
        if (this.isDesktop) {
          // モバイル→デスクトップ：Lenisを初期化
          this.initLenis();
          this.headerScrollControl();
        } else {
          // デスクトップ→モバイル：Lenisを破棄
          this.destroyLenis();
          this.setupNativeScrollListener();
        }
        
        // アンカーリンクの設定を更新
        this.setupAnchorLinks();
      }
    });
  }

  setupDrawerLenisControl() {
    $(document).on('click', '.js-drawer-btn', () => {
      if (this.lenis && this.isDesktop) {
        if ($('html').hasClass('is-drawer-open')) {
          this.lenis.stop();
        } else {
          this.lenis.start();
        }
      }
    });
  }

  headerScrollControl(){
    const header = document.querySelector('.js-header');
    if (!header) return;

    // PCでLenisが有効な場合はLenisのスクロールイベントを使用
    if (this.lenis && this.isDesktop) {
      this.lenis.on('scroll', (e) => {
        this.updateHeaderPosition(e.scroll);
      });
    } else {
      // モバイルまたはLenisが無効な場合は通常のスクロールイベントを使用
      this.setupNativeScrollListener();
    }
  }

  updateHeaderPosition(currentScrollY){
    const header = document.querySelector('.js-header');
    if (!header) return;

    // スクロール位置が100px以下の場合は常に表示
    if (currentScrollY <= 100) {
      header.style.transform = 'translateY(0)';
      header.style.transition = 'transform 0.3s ease';
      this.lastScrollY = currentScrollY;
      return;
    }

    // スクロール方向を判定
    if (currentScrollY > this.lastScrollY) {
      // 下にスクロール中 - ヘッダーを非表示
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.3s ease';
    } else {
      // 上にスクロール中 - ヘッダーを表示
      header.style.transform = 'translateY(0)';
      header.style.transition = 'transform 0.3s ease';
    }

    this.lastScrollY = currentScrollY;
  }

  setupNativeScrollListener(){
    if (this._nativeScrollBound) return;
    this._nativeScrollBound = true;

    const header = document.querySelector('.js-header');
    if (!header) return;

    let ticking = false;
    
    const updateHeader = () => {
      const currentScrollY = window.pageYOffset;
      this.updateHeaderPosition(currentScrollY);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }
}
